// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_core__GlobalStateContext from "../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_landing__ButtonPrimary from "../../../components/landing/ButtonPrimary.js";
import * as Buhta_landing__EventHandlers from "../../../util/EventHandlers.js";
import * as Buhta_landing__I18n from "../../../util/i18n/I18n.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

const faq = {
  hd: {
    question: "Как подключить?",
    answer: "Зарегистрируйтесь на нашем сайте и перейдите в раздел Помощь. Нажмите \"Создать новый тикет\", опишите свою задачу и нажмите кнопку Отправить. После этого в тикет вам придет сообщение о том, как мы можем помочь с вашей задачей, и будут переданы контакты вашего менеджера. Также вы можете самостоятельно зарегистрировать кассу, если вам не нужна автоматическая интеграция, и вы бы хотели выбивать чеки вручную. Для этого перейдите в раздел \"Касса\" и нажмите кнопку \"Зарегистрировать кассу\", далее следуйте инструкции. Если вы хотите получить консультацию по кассам по телефону - позвоните нам."
  },
  tl: {
    hd: {
      question: "Как работать?",
      answer: "Для того чтобы пользоваться кассой вам необходимо оплатить использование кассы и услуги ОФД, выбранного вами. В противном случае касса не сможет функционировать в штатном режиме.   После оплаты услуг Бухты и ОФД вам будет доступна функция создания чеков. Создавайте чеки при каждой реализации следуя инструкции в кабинете."
    },
    tl: {
      hd: {
        question: "Какие данные мне будут доступны?",
        answer: "Вам будут доступны данные обо всех продажах, Z и X отчеты, данные по возвратам. Вы сможете самостоятельно просмотреть все данные за определенный период. Данные хранятся 5 лет.  Что будет если произойдет ошибка?  В случае если произойдет ошибка вам нужно связаться нами для выявления причин ошибки и ее устранения."
      },
      tl: {
        hd: {
          question: "Что будет если ОФД не будет доступен в момент выдачи чека?",
          answer: "В этом случае наша система дождется того момента, когда он будет доступен и проведет чек как полагается и отправит его клиенту."
        },
        tl: /* [] */ 0
      }
    }
  }
};

function KassaEpilogue(Props) {
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const intl = ReactIntl.useIntl();
  const match = React.useState(function () {
    return /* [] */ 0;
  });
  const setIdxes = match[1];
  const idxes = match[0];
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("h2", {
                children: "Попробуйте нашу кассу прямо сейчас",
                className: "h4 lg:h2 text-white text-center lg:text-left lg:w-130"
              }),
              JsxRuntime.jsx("p", {
                children: "Зарегистрируйте кассу или зарегистрируйтесь и обратитесь в раздел \"Помощь\".",
                className: "paragraph lg:paragraph-large opacity-64 text-white text-center lg:text-left lg:w-130 mt-2"
              }),
              JsxRuntime.jsx(Buhta_landing__ButtonPrimary.make, {
                classes: {
                  hd: "flex m-auto mt-6 lg:mt-10",
                  tl: /* [] */ 0
                },
                label: Buhta_landing__I18n.trans(intl, "start_using"),
                onClick: (function (param) {
                  Buhta_landing__EventHandlers.scrollToFooter(deviceType);
                })
              })
            ],
            className: "pt-10 lg:pt-16 lg:pb-19 px-6 sm:px-48 lg:pl-18 lg:pr-0"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("img", {
              alt: "kassa try",
              src: StaticAsset.src("/static/images/kassa-try.svg")
            }),
            className: "mt-10 lg:mt-0 px-6 sm:px-48 lg:px-0 lg:ml-35.25 self-end"
          })
        ],
        className: Cn.fromList({
          hd: "lg:w-304 lg:flex lg:m-auto lg:mt-20 lg:rounded-sm bg-black-landing",
          tl: /* [] */ 0
        })
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            src: StaticAsset.src("/static/icons/guard-circled.svg")
          }),
          JsxRuntime.jsx("h3", {
            children: "Если что-то пойдет не так?",
            className: "h4 lg:h3 text-center text-black-landing lg:mt-4"
          }),
          JsxRuntime.jsx("p", {
            children: "В случае возникновения вопросов по работе с кассой вы всегда можете обратиться в нашу службу поддержки, которая поможет вам решить проблему. В случае если вы работаете с автоматизированной системой, то наша касса передаст ей детализированные статусы, которые помогут вам быстро разобраться в чем дело.",
            className: "paragraph lg:h-light text-center text-gray-landing lg:w-192 mt-2"
          })
        ],
        className: "flex m-auto lg:mt-30 flex-col items-center lg:rounded-sm lg:w-252 px-6 sm:px-48 lg:px-0 pt-8 lg:pt-18 pb-10 lg:pb-20 bg-bg"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("h3", {
            children: "Ответы на часто задаваемые вопросы",
            className: "h4 lg:h3 text-black-landing mb-6 lg:mb-16 lg:w-120"
          }),
          Belt__Belt_List.toArray(Stdlib__List.mapi((function (i, d) {
            const Key = "faq_" + String(i);
            return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("h6", {
                      children: d.question,
                      className: "h6 text-black-landing"
                    }),
                    Stdlib__List.exists((function (idx) {
                      return idx === i;
                    }), idxes) ? JsxRuntime.jsx("img", {
                        src: StaticAsset.src("/static/icons/minus.svg")
                      }) : JsxRuntime.jsx("img", {
                        src: StaticAsset.src("/static/icons/plus-black.svg")
                      })
                  ],
                  className: "flex justify-between h-16 border-b border-divider items-center cursor-pointer",
                  onClick: (function (param) {
                    if (Stdlib__List.exists((function (idx) {
                        return idx === i;
                      }), idxes)) {
                      return Curry._1(setIdxes, (function (state) {
                        return Stdlib__List.filter((function (item) {
                          return item !== i;
                        }), state);
                      }));
                    } else {
                      return Curry._1(setIdxes, (function (state) {
                        return Stdlib__List.append(state, {
                          hd: i,
                          tl: /* [] */ 0
                        });
                      }));
                    }
                  })
                }),
                JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx("p", {
                    children: d.answer,
                    className: "paragraph text-gray-landing whitespace-pre-line"
                  }),
                  className: Cn.fromList({
                    hd: "border-b border-divider py-6",
                    tl: {
                      hd: Stdlib__List.exists((function (idx) {
                        return idx === i;
                      }), idxes) ? "block" : "hidden",
                      tl: /* [] */ 0
                    }
                  })
                })
              ]
            }, Key);
          }), faq))
        ],
        className: "flex m-auto flex-col py-10 sm:py-20 lg:py-30 px-6 sm:px-48 lg:px-0 lg:w-148"
      })
    ]
  });
}

const make = KassaEpilogue;

export {
  faq,
  make,
}
/* Buhta_core__GlobalStateContext Not a pure module */
